import moment from 'moment'

export const toAdministrationTimeString = (moment: moment.Moment) => {
    const outputFormat = 'YYYY-MM-DDTHH:mm:ssZ'
    const zeroSecondsMoment = moment
    zeroSecondsMoment.set({ seconds: 0 })

    return zeroSecondsMoment.format(outputFormat)
}

export const toAdministrationsViewMoment = (timeString: string) => {
    const outputFormat = 'DD/MM/YYYY hh:mm:ss A Z'

    return moment(timeString, outputFormat)
}

export const toDatePickerMoment = (timeString: string) => {
    const outputFormat = 'YYYY-MM-DDTHH:mm:ssZ'

    return moment(timeString, outputFormat)
}

export const toTimeZoneString = (timeString: string | moment.Moment) => {
    const inputFormat = 'YYYY-MM-DDTHH:mm:ssZ'
    const outputFormat = 'DD/MM/YYYY hh:mm:ss A Z'

    const date = moment(timeString, inputFormat)

    return date.format(outputFormat)
}